import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import Listing from "../views/Listing.vue";
import Detail from "../views/Detail.vue";
import Account from "../views/Account.vue";
import Forbidden from "../views/Forbidden.vue";
import NotFound from "../views/NotFound.vue";
import Groups from "../views/Groups.vue";
import AjoutDossier from "../views/AjoutDossier.vue";
import Password from "../views/Password.vue";
import ForgotPassword from "../views/ForgotPassword.vue";
import Logs from "../views/History.vue";
import Documents from "../views/Documents.vue";
import Delays from "../views/Delays.vue";
import Ineris from "../views/Ineris.vue";
import Cerfa from "../views/Cerfa.vue";
import Users from "../views/Users.vue";
import Statistics from "../views/Statistics.vue";
import BroadcastMessage from "../views/BroadcastMessage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "dossiers",
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      title: "ADN83 | Authentification",
    },
  },
  {
    path: "/password/:token",
    name: "Password",
    component: Password,
    meta: {
      title: "ADN83 | Nouveau mot de passe",
    },
  },
  {
    path: "/forgot-pass",
    name: "ForgotPassword",
    component: ForgotPassword,
    meta: {
      title: "ADN83 | Mot de passe oublié",
    },
  },
  {
    path: "/dossiers/:id",
    name: "Dossier",
    component: Detail,
    meta: {
      requiresAuth: true,
      title: "ADN83 | Détail demande",
    },
  },


  {
    path: "/account",
    name: "Account",
    component: Account,
    meta: {
      requiresAuth: true,
      title: "ADN83 | Mon compte",
    },
  },

  {
    path: "/user",
    name: "NewUser",
    component: Account,
    meta: {
      requiresAuth: true,
      title: "ADN83 | Nouvel utilisateur",
    },
  },

  {
    path: "/users",
    name: "Users",
    component: Users,
    meta: {
      requiresAuth: true,
      title: "ADN83 | Liste des utilisateurs",
    },
  },

  {
    path: "/users/:id",
    name: "User",
    component: Account,
    meta: {
      requiresAuth: true,
      title: "ADN83 | Informations de l'utilisateur",
    },
  },

  {
    path: "/cerfa/:type/:id",
    name: "Cerfa",
    component: Cerfa,
    meta: {
      requiresAuth: true,
      title: "ADN83 | Visualisation Cerfa",
    },
  },
  {
    path: "/dossiers",
    name: "Dossiers",
    component: Listing,
    meta: {
      requiresAuth: true,
      title: "ADN83 | Liste des demandes", //,
      // roles: ['ROLE_GUICHET']
    },
  },
  {
    path: "/retards",
    name: "Delays",
    component: Delays,
    meta: {
      requiresAuth: true,
      title: "ADN83 | Liste des demandes en retard", //,
      roles: ['ROLE_ADMIN', 'ROLE_GUICHET', "ROLE_GESTIONNAIRE"]
    },
  },
  {
    path: "/groups/:type",
    name: "Groupes",
    component: Groups,
    meta: {
      requiresAuth: true,
      title: "ADN83 | Groupes",
      roles: ["ROLE_ADMIN"],
    },
  },
  {
    path: "/history",
    name: "History",
    component: Logs,
    meta: {
      requiresAuth: true,
      title: "ADN83 | Historique",
      roles: ["ROLE_ADMIN"],
    },
  },
  {
    path: "/documents",
    name: "Documents",
    component: Documents,
    meta: {
      requiresAuth: true,
      title: "ADN83 | Documents",
      // roles: ["ROLE_ADMIN"],
    },
  },
  {
    path: "/statistics",
    name: "statistics",
    component: Statistics,
    meta: {
      requiresAuth: true,
      title: "ADN83 | Statistiques",
      // roles: ["ROLE_ADMIN"],
    },
  },
  {
    path: "/ineris",
    name: "Ineris",
    component: Ineris,
    meta: {
      requiresAuth: true,
      title: "ADN83 | Ineris",
      // roles: ["ROLE_ADMIN"],
    },
  },
  {
    path: "/ajoutdossier",
    name: "ajoutdossier",
    component: AjoutDossier,
    meta: {
      requiresAuth: true,
      title: "ADN83 | Nouvelle demande", //,
      // roles: ['ROLE_GESTIONNAIRE']
    },
  },
  {
    path: "/message",
    name: "broadcastMessage",
    component: BroadcastMessage,
    meta: {
      requiresAuth: true,
      title: "ADN83 | Message général",
      roles: ['ROLE_ADMIN']
    },
  },
  // {
  //   path: "/catalogue",
  //   name: "catalogue",
  //   component: Catalogue,
  //   meta: {
  //     requiresAuth: true,
  //     title: "Sud-THD | catalogue", //,
  //     // roles: ['ROLE_GESTIONNAIRE']
  //   },
  // },
  {
    path: "/updatedossier/:id",
    name: "updatedossier",
    component: AjoutDossier,
    meta: {
      requiresAuth: true,
      title: "ADN83 | Mise à jour de la demande",
      roles: ["ROLE_USER"],
    },
  },
  {
    path: "/403",
    name: "Forbidden",
    component: Forbidden,
    meta: {
      title: "ADN83 | Accès refusé",
      requiresAuth: true,
    }
  },
  {
    path: "/404",
    component: NotFound,
    meta: {
      title: "ADN83 | Page non trouvée",
      requiresAuth: true,
    },
  },
  {
    path: "*",
    redirect: "/404",
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
